import { styled as t } from "styled-components";
import { Avatar as o } from "../../../../../components/Avatar/index.js";
import { Body as r, Caption as a, CaptionHeavy as i } from "../../../../../styles/typography/index.js";
import { Theme as e } from "../../../../../styles/themes/index.js";
const d = t.div`
  ${r}
  height: auto;
  width: 100%;

  white-space: nowrap;
  text-align: left;

  ${a}

  strong {
    color: rgb(${e.colors.Alpha});
    ${i}
  }
`, l = t.div`
  display: flex;
  overflow: hidden;
  background: transparent;
  align-items: center;
  width: 100%;
`, m = t(o)`
  margin-right: 8px;
  flex-shrink: 0;

  &[data-size] {
    width: 24px;
    height: 24px;
  }
`;
export {
  m as Avatar,
  l as Container,
  d as Content
};
